import { jsxs as _jsxs, jsx as _jsx } from "@emotion/react/jsx-runtime";
function VehicleTitle(props) {
    if (!props.merk && !props.modelH && !props.type) {
        return null;
    }
    return (_jsxs("div", { className: "detail-content-box detail-content-box--sidebar detail-content-box--title", children: [_jsxs("h1", { className: "detail-title", children: [props.merk, " ", props.modelH] }), _jsx("h2", { className: "detail-sub-title", children: props.type })] }));
}
export { VehicleTitle };
